import { SphereGeometry } from "three";

export const sphereGeometry = new SphereGeometry(0.15, 30, 20);
